let baseVars = require('./base.js').default
if (process.env.VUE_APP_ENV === 'localprod') {
  // 本地部署域名覆盖
  const locals = require('./local.js').default
  baseVars = { ...baseVars, ...locals }
}

export const {
  hostDomain,
  UMOOC_COOKIE_DOMAIN,
  COURSE_API_HOST,
  API_HOST,
  KG_API_HOST,
  TEST_API_HOST,
  UTEST_WEB_HOST,
  UTEST_API_HOST,
  UA_API_HOST,
  QINIU_BASE64_URL,
  RESOURCE_SERVER_HOST,
  RESOURCE_DOWNLOAD_HOST,
  DOCS_HOST,
  UMOBILE_HOST,
  UMOOC_SERVER_HOST,
  KNOWLEDGE_GRAPH_WEB_HOST,
  UA_WEB_HOST,
  COURSE_WEB_HOST,
  WXPCLOGINAPPID,
  WXGZHAPPID,
  ORG_SITE,
  isI18n,
  UPLOAD_SERVER_HOST,
  UPLOAD_SERVER_PROTOCOL,
  IS_SELF_UPLOAD,
  UMOOC_WEB_HOST,
  TONGLAB_WEB_HOST,
  ULAB_WEB_HOST
} = baseVars
